<div *ngIf="user" class="card-header">
  <h1 class="ignore-lowercase">welkom <span class="hide-on-small-phone">{{user.firstName}}<span class="hide-on-phone"> {{user.insertion}} {{user.lastName}}</span></span></h1>
</div>
<div *ngIf="!isLoading" class="card-body">
  <div class="relative">
    <div class="w800">
      <div *ngIf="clients.length > 0">
        <h2>Overzicht van uw bewinden</h2>
        <div *ngFor="let client of clients;"
             [routerLink]="'/bewind/'+client.id"
             class="pointer rounded-indent full-width mb20">
          {{client.firstName}} {{client.insertion}} {{client.lastName}}
        </div>
      </div>
      <div *ngIf="clients.length == 0">
        <p>klik op bewind aanmaken om een nieuw bewind toe te voegen</p>
      </div>
    </div>
    <div class="btn-container" [ngClass]="{'add-first-client': clients.length == 0}">
      <button class="btn plus" routerLink="/bewind/toevoegen">bewind aanmaken</button>
    </div>
  </div>
  <app-task-list level="LOW"></app-task-list>
</div>
